import { useLocation } from "react-router";

export default function Search() {
  const { search } = useLocation();
  console.log(search);
  return <div>Search: {search}</div>;
}
